import { useContext } from 'react';
import { ICurrentPersonContext, CurrentPersonContext } from '../contexts';

export const useCurrentPerson = (): ICurrentPersonContext => {
  const context = useContext(CurrentPersonContext);

  return context;
};
